/**
 * HomeLocationsSection — restrained homepage section introducing the five
 * VidaVital markets and linking to /locations. Consistent with the current
 * visual system: neutral card grid, no imagery, no efficacy claims, no
 * appointment promises. Every card links to its detail page.
 */
import { Link } from "react-router-dom";
import { MapPin, ArrowRight } from "lucide-react";
import { CLINICS } from "../data/clinics";

export default function HomeLocationsSection() {
  return (
    <section
      data-testid="home-locations-section"
      className="vv-container py-14 md:py-20"
    >
      <div className="flex items-end justify-between gap-6 flex-wrap">
        <div>
          <div className="text-[11px] uppercase tracking-[0.25em] text-[color:var(--vv-gold-deep)] font-semibold">Where we work</div>
          <h2 className="mt-3 font-display text-3xl md:text-4xl leading-tight max-w-2xl">Five VidaVital clinic markets.</h2>
          <p className="mt-3 text-stone-600 max-w-2xl">Licensed medical providers see patients in-clinic and, where clinically appropriate, by secure-video telehealth. Every patient starts with a provider evaluation.</p>
        </div>
        <Link
          to="/locations"
          data-testid="home-locations-directory-link"
          className="inline-flex items-center gap-2 rounded-full border border-stone-300 px-4 py-2 text-sm font-semibold text-[color:var(--vv-ink)] hover:border-[color:var(--vv-teal)] hover:text-[color:var(--vv-teal)] transition-colors"
        >
          All locations <ArrowRight size={14} />
        </Link>
      </div>
      <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-5 gap-3">
        {CLINICS.map((c) => (
          <Link
            key={c.slug}
            to={`/locations/${c.slug}`}
            data-testid={`home-locations-card-${c.slug}`}
            className="group rounded-xl border border-stone-200 bg-white p-4 hover:border-[color:var(--vv-teal)] hover:shadow-md transition"
          >
            <div className="flex items-center gap-2 text-[color:var(--vv-teal)]">
              <MapPin size={14} />
              <span className="text-[10px] uppercase tracking-[0.18em] font-semibold">{c.state}</span>
            </div>
            <div className="mt-2 font-display text-lg leading-tight text-stone-900 group-hover:text-[color:var(--vv-teal)]">{c.name}</div>
            <div className="mt-1 text-xs text-stone-500">{c.metro}</div>
          </Link>
        ))}
      </div>
    </section>
  );
}
